// Validação de guia de tamanhos client-side (RN-G03, docs/specs/2026-09-23-
// guia-de-tamanhos-design.md secao 3) — espelha a validação que o backend
// também faz; aqui é só pra dar mensagem clara ANTES de salvar, nunca
// substitui a validação do servidor.
import type { SizeGuideRow } from "./types";

export const SIZE_GUIDE_MAX_COLUMNS = 8;
export const SIZE_GUIDE_MAX_ROWS = 15;
export const SIZE_GUIDE_MAX_VALUE_LEN = 20;

export interface SizeGuideValidationError {
  field: "columns" | "rows";
  index?: number;
  message: string;
}

/** RN-G03: columns 1..8 nao vazias e unicas; rows 1..15; size nao vazio e
 * unico; values.length === columns.length; cada valor <= 20 chars. */
export function validateSizeGuideTable(
  columns: string[],
  rows: SizeGuideRow[],
): SizeGuideValidationError[] {
  const errors: SizeGuideValidationError[] = [];

  if (columns.length === 0) {
    errors.push({ field: "columns", message: "Adicione pelo menos 1 coluna de medida." });
  } else if (columns.length > SIZE_GUIDE_MAX_COLUMNS) {
    errors.push({ field: "columns", message: `No máximo ${SIZE_GUIDE_MAX_COLUMNS} colunas.` });
  }
  columns.forEach((c, i) => {
    if (!c.trim()) errors.push({ field: "columns", index: i, message: `A coluna ${i + 1} está sem nome.` });
  });
  const colNames = columns.map((c) => c.trim().toLowerCase());
  const dupCols = colNames.filter((c, i) => c && colNames.indexOf(c) !== i);
  if (dupCols.length > 0) {
    errors.push({ field: "columns", message: `Colunas repetidas: ${Array.from(new Set(dupCols)).join(", ")}.` });
  }

  if (rows.length === 0) {
    errors.push({ field: "rows", message: "Adicione pelo menos 1 linha de tamanho." });
  } else if (rows.length > SIZE_GUIDE_MAX_ROWS) {
    errors.push({ field: "rows", message: `No máximo ${SIZE_GUIDE_MAX_ROWS} linhas.` });
  }
  const sizeNames = rows.map((r) => r.size.trim().toLowerCase());
  rows.forEach((r, i) => {
    if (!r.size.trim()) {
      errors.push({ field: "rows", index: i, message: `A linha ${i + 1} está sem tamanho.` });
    } else if (sizeNames.indexOf(r.size.trim().toLowerCase()) !== i) {
      errors.push({ field: "rows", index: i, message: `Tamanho "${r.size}" repetido.` });
    }
    if (r.values.length !== columns.length) {
      errors.push({
        field: "rows",
        index: i,
        message: `A linha "${r.size || i + 1}" tem ${r.values.length} valor(es), mas há ${columns.length} coluna(s).`,
      });
    }
    r.values.forEach((v, vi) => {
      if (v.length > SIZE_GUIDE_MAX_VALUE_LEN) {
        errors.push({
          field: "rows",
          index: i,
          message: `Linha "${r.size || i + 1}", coluna ${vi + 1}: valor muito longo (máx. ${SIZE_GUIDE_MAX_VALUE_LEN} chars).`,
        });
      }
    });
  });

  return errors;
}

/** Cria uma linha nova com values do tamanho certo (uma string vazia por coluna). */
export function emptySizeGuideRow(nColumns: number, size = ""): SizeGuideRow {
  return { size, values: Array.from({ length: nColumns }, () => "") };
}
